var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page', {
    attrs: {
      "title": "chill"
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "1000px",
      "src": "https://www.youtube-nocookie.com/embed/5qap5aO4i9A",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }